import { Link } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="bg-white min-h-screen" data-testid="not-found-page">
      <Seo title="Page Not Found | Royal Deals FZ-LLC" description="The requested page could not be found." robots="noindex" />
      <Nav />
      <main className="pt-44 pb-24">
        <div className="max-w-[720px] mx-auto px-6 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold mb-6">404</p>
          <h1 className="font-heading text-4xl font-light tracking-tight text-midnight">This page does not exist.</h1>
          <p className="text-midnight/55 mt-5">The page you are looking for may have moved. These links will get you back on track:</p>
          <div className="flex flex-wrap justify-center gap-4 mt-10">
            <Link to="/" className="bg-midnight text-white text-sm font-medium px-8 py-3.5 hover:bg-midnight-light transition-colors">Home</Link>
            <Link to="/products" className="border border-midnight/20 text-midnight text-sm font-medium px-8 py-3.5 hover:border-gold hover:text-gold transition-colors">Products</Link>
            <Link to="/request" className="border border-midnight/20 text-midnight text-sm font-medium px-8 py-3.5 hover:border-gold hover:text-gold transition-colors">Request Hardware</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
